import React from "react";
import { observer } from "mobx-react-lite";
import styled, { keyframes } from "styled-components";
import { FontFamily } from "./GameUIElements";
import AnimatedText from "react-animated-text-content";
import { GrFormNextLink } from "react-icons/gr";
import { CutSceneController } from "../../../canvas/game/controller/CutSceneController";
import { useTranslation } from "react-i18next";
import { TextParser } from "../TextParser";
import { gameStore } from "../../../stores/GameStore";
const Row = styled.div.withConfig({
  displayName: "SimpleCutSceneUI__Row",
  componentId: "sc-1l520nk-0"
})(["display:flex;flex-direction:row;justify-content:end;"]);

function blinkingEffect() {
  return keyframes(["50%{transform:scale(1.10);-webkit-transform:scale(1.10);}"]);
}

const ContinueButton = styled.div.withConfig({
  displayName: "SimpleCutSceneUI__ContinueButton",
  componentId: "sc-1l520nk-1"
})(["background-color:white;color:black;padding-left:20px;padding-right:20px;padding-top:6px;margin:6px;animation:", " 1s ease infinite;border-radius:4px;font-size:xx-large;cursor:pointer;border:4px solid black;"], blinkingEffect);
const StyledAnimatedText = styled(AnimatedText).withConfig({
  displayName: "SimpleCutSceneUI__StyledAnimatedText",
  componentId: "sc-1l520nk-2"
})(["background-color:", ";color:", ";padding:16px;font-size:x-large;border-radius:4px;", " text-align:justify;border:4px solid black;"], props => props.backgroundColor, props => props.textColor, FontFamily);
const Container = styled.div.withConfig({
  displayName: "SimpleCutSceneUI__Container",
  componentId: "sc-1l520nk-3"
})(["flex-basis:", ";"], props => props.flexBasis + "%");
export const SimpleCutSceneUI = observer(({
  sceneProps: sceneProps
}) => {
  var _gameStore$cutSceneAn, _gameStore$cutSceneAn2, _gameStore$cutSceneAn3;

  const {
    t
  } = useTranslation();
  const currentTextIndex = gameStore.gameEngine.gameState.actionPropertyCurrentCutSceneTextIndex;

  function onClickContinue() {
    if (currentTextIndex == sceneProps.text.length - 1) {
      CutSceneController.endCutScene(sceneProps.sourceActionModelId);
    } else {
      gameStore.gameEngine.gameState.setActionPropertyCurrentCutSceneTextIndex(currentTextIndex + 1);
    }
  }

  const parser = new TextParser();
  parser.parseString(sceneProps.text[currentTextIndex], gameStore.gameEngine.getCachedActionNode(sceneProps.sourceActionModelId), t);
  return /*#__PURE__*/React.createElement(Container, {
    flexBasis: sceneProps.textContainerWidthPercent[currentTextIndex]
  }, /*#__PURE__*/React.createElement(Row, null, ((_gameStore$cutSceneAn = gameStore.cutSceneAnimationStore) === null || _gameStore$cutSceneAn === void 0 ? void 0 : _gameStore$cutSceneAn.currentlyLoadingAnimation) && /*#__PURE__*/React.createElement(ContinueButton, null, t("game.loading") + "..."), !((_gameStore$cutSceneAn2 = gameStore.cutSceneAnimationStore) !== null && _gameStore$cutSceneAn2 !== void 0 && _gameStore$cutSceneAn2.currentlyLoadingAnimation) && /*#__PURE__*/React.createElement(ContinueButton, {
    onClick: onClickContinue
  }, /*#__PURE__*/React.createElement(GrFormNextLink, null))), sceneProps.text && !((_gameStore$cutSceneAn3 = gameStore.cutSceneAnimationStore) !== null && _gameStore$cutSceneAn3 !== void 0 && _gameStore$cutSceneAn3.currentlyLoadingAnimation) && /*#__PURE__*/React.createElement(StyledAnimatedText, {
    backgroundColor: sceneProps.textStyle[currentTextIndex] == 1 ? "white" : "black",
    textColor: sceneProps.textStyle[currentTextIndex] == 1 ? "black" : "white",
    type: "chars",
    interval: sceneProps.enabledTypeAnimation[currentTextIndex] ? 0.02 : 0.00001,
    duration: sceneProps.enabledTypeAnimation[currentTextIndex] ? 0.01 : 0.00001,
    animation: {
      ease: 'linear'
    }
  }, parser.toString()));
});